import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchBarComponent {
  @Input() width?: number = 300;
  @Input() placeholder?: string = 'Search';
  @Input() value?: string = '';
  @Input() minLength: number = 4;
  @Input() searchByList: { label: string; value: string }[] = [];
  @Input() searchBy: string;
  @Output() onSearchChanges = new EventEmitter<string>();
  @Output() onSearchByChanges = new EventEmitter<string>();

  onChange(e: string) {
    if (e.length >= this.minLength || !e.length) {
      this.onSearchChanges.emit(e);
    }
  }

  onSearchByChange(e: string) {
    this.value = '';
    this.onSearchByChanges.emit(e);
  }

  onClearValue() {
    this.value = '';
    this.onSearchChanges.emit(this.value);
  }
}
